import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import arrowIcon from "@/assets/return_icon_blk.svg";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  termWrapper: {
    background: "#c8c8c8",
    width: "100vw",
    height: "100vh",
    overflow: "auto",
  },
  header: {
    color: "#555",
    textAlign: "center",
    position: "sticky",
    top: 0,
    left: 0,
    background: "#c8c8c8",
  },
  title: {
    margin: 0,
    padding: "16px 0",
  },
  arrow: {
    position: "absolute",
    top: "50%",
    left: "16px",
    transform: "translateY(-50%)",
  },
  main: {
    maxWidth: 800,
    margin: " 50px auto 30px",
  },
});

const PolicyWrapper = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { title, children } = props;
  return (
    <div className={classes.termWrapper}>
      <header className={classes.header}>
        <img
          className={classes.arrow}
          src={arrowIcon}
          onClick={() => navigate(-1)}
        />
        <h1 className={classes.title}>{title}</h1>
      </header>
      <main className={classes.main}>
        <Paper elevation={3}>{children}</Paper>
      </main>
    </div>
  );
};

export default PolicyWrapper;
